exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".PayOferta_oferta_21JW {\n  margin-bottom: 15px;\n\n  font-size: 15px;\n  font-style: italic;\n}\n\n.PayOferta_ofertalink_acax {\n  padding: 0 5px;\n}\n\n.PayOferta_oferta_21JW,\n.PayOferta_ofertalink_acax {\n  color: #787878;\n}\n", ""]);

// exports
exports.locals = {
	"oferta": "PayOferta_oferta_21JW",
	"ofertalink": "PayOferta_ofertalink_acax"
};